<template>
  <div class="menu-dropdown-wrap menu-dropdown-wrap--open-one">
    <div class="menu-dropdown" @click="OpenMenu">
      <div class="menu-dropdown-top">
        <div class="menu-dropdown__icon-company">
          <img :src="selectCompany.q_logo" alt @error="handleImgError" />
        </div>
        <div class="menu-dropdown__name">{{selectCompany.company_name ?? 'Selecionar empresa'}}</div>
        <div class="menu-dropdown__arrow">
          <img src="../assets/arrow-down.svg" alt />
        </div>
      </div>
      <ul class="menu-dropdown-bottom" :class="{'menu-dropdown-bottom--close':menuDropdownBottom}">
        <li @click="ChangeCompany(item._id)" v-for="item in companyList" :key="item._id">
          <div class="menu-dropdown__icon-company">
            <img :src="companyListImgPath(item)" alt @error="handleImgError"/>
          </div>
          <div class="menu-dropdown__name">{{item.company_name}}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import config from '../config';

export default {
  data() {
    return {
      stateNow: "open",
      finalState: false,
      menuOpen: false,
      menuDropdownName: true,
      menuDropdownBottom: true,
      icon: "arrow-down.svg",
      selectCompany: "",
      companyList: [],
      imgPath: config.URL_IMAGE + "/imagens/",
    };
  },
  methods: {
    OpenMenu() {
      if (this.stateNow === "open") {
        this.menuDropdownBottom = false;
        this.stateNow = "close";
        this.icon = "arrow-up.svg";
      } else if (this.stateNow === "close") {
        this.menuDropdownBottom = true;
        this.stateNow = "open";
        this.icon = "arrow-down.svg";
      }
    },
    MountCompanyList() {
      //SE FOR O MASTER OBTEM A LISTA PELO VALOR DENTRO DE DE COMPANY_LIST
      if (this.$store.state.user_data.master) {
        this.companyList = this.$store.state.company_list;
        const company_select = this.$store.state.company_select;
        this.companyList.map(values => {
          if (values._id == company_select) {
            this.selectCompany = values;
          }
        });
      } else {
        this.companyList = [];
        //QUANDO NAO FOR O MASTER IRA CARREGAR AS EMPRESAS QUE TEM ACESSO
        const companys = this.$store.state.user_data.meta
          .instituicoes_vinculadas;

        const company_select = this.$store.state.company_select;

        companys.map(values => {
          console.log(values);
          let temp = {};
          temp._id = values.id;
          temp.company_name = values.nome_empresa;
          temp.q_logo = values.logo;
          if (values.id == company_select) {
            this.selectCompany = temp;
          }
          this.companyList.push(temp);
        });
      }
    },
    ChangeCompany(id) {
      this.$store.commit("SetCompanySelect", id);
      this.MountCompanyList();
      this.$parent.Update();
    },
    handleImgError(event) {
      event.target.src = this.imgPath + "icones/unknown.png";
    },
    companyListImgPath(company) {
      return company.q_logo.includes("https")
        ? company.q_logo
        : this.imgPath + "instituicoes/" + company.q_logo;
    }
  },
  mounted() {
    this.MountCompanyList();
  }
};
</script>

<style scoped>
.menu-dropdown__icon-company{
  width: 38px;
  height: 38px;
}

.menu-dropdown__icon-company img{
  width: 100% !important;
  height: 100% !important;
  border-radius: 50% !important;
  object-fit: cover;
}

.menu-dropdown-bottom{
  max-height: 80vh !important;
  overflow-y: auto !important;
}
</style>